import script from "./TutorialPlaylist.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorialPlaylist.vue?vue&type=script&setup=true&lang=js"

import "./TutorialPlaylist.vue?vue&type=style&index=0&id=ec1cac1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec1cac1a"]])

export default __exports__